import { Injectable } from '@angular/core';

const DEVICE_TOKEN_KEY = 'sfx_device_token';

/**
 * Registered-device token (tiered disclosure).
 *
 * A device that has been enrolled (via an admin enrollment link or patient
 * self-registration) holds a long-lived opaque token in localStorage. The
 * PUBLIC break-glass verify calls attach it as `X-Device-Token` so the backend
 * can return the FULL document; unregistered devices only get the minimal
 * emergency summary. The token is NEVER attached to authenticated API calls
 * and is never rendered in the UI.
 */
@Injectable({ providedIn: 'root' })
export class DeviceTokenService {
  public getToken(): string | null {
    try {
      return window.localStorage.getItem(DEVICE_TOKEN_KEY);
    } catch (e) {
      return null;
    }
  }

  public setToken(token: string): void {
    try {
      window.localStorage.setItem(DEVICE_TOKEN_KEY, token);
    } catch (e) {
      /* storage unavailable (private mode) — verify falls back to minimal tier */
    }
  }

  public clear(): void {
    try {
      window.localStorage.removeItem(DEVICE_TOKEN_KEY);
    } catch (e) {
      /* noop */
    }
  }

  public hasToken(): boolean {
    return !!this.getToken();
  }
}
